import { Checkbox, TableCell } from "@mui/material";

interface ChildPartColumnProps {
  version: "v1" | "v2";
  isAllSelected: boolean;
  handleSelectAll: (checked: boolean) => void;
  isAdding: boolean;
  isEditing: boolean;
}

const ChildPartColumn = ({
  version,
  isAllSelected,
  handleSelectAll,
  isAdding,
  isEditing,
}: ChildPartColumnProps) => {
  return (
    <>
      <TableCell
        sx={{
          position: "sticky",
          left: 0,
          zIndex: 102,
          width: 70,
          minWidth: 70,
          maxWidth: 70,
          textAlign: "center",
          borderRight: "1px solid #e0e0e0",
        }}
      >
        <Checkbox
          checked={isAllSelected}
          onChange={(e) => handleSelectAll(e.target.checked)}
          disabled={version === "v1" || isAdding || isEditing}
          color="warning"
          sx={{
            backgroundColor: "white",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: "white",
            },
          }}
        />
      </TableCell>
      <TableCell
        sx={{
          position: "sticky",
          left: 70,
          zIndex: 102,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          borderRight: "2px solid #e0e0e0",
        }}
      >
        Child Part No.
      </TableCell>
      <TableCell
        sx={{
          position: "sticky",
          left: 220,
          zIndex: 102,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          borderRight: "2px solid #e0e0e0",
        }}
      >
        Child Part Name
      </TableCell>
    </>
  );
};

export default ChildPartColumn;
